module.exports = __webpack_public_path__ + "202b53350f0356edfc5ca8c9bc31bc86.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/datagand_active.png
// module id = 322
// module chunks = 3